import React from "react";
import styles from "./Button.module.css";
import classNames from "classnames";

export function Button({ buttonText, onClick, className, disabled }) {
  let buttonStyle = styles.button;

  if (
    buttonText === "Close" ||
    buttonText === "Sort" ||
    buttonText === "Next" ||
    buttonText === "Yes" ||
    buttonText === "View"
  ) {
    buttonStyle = styles.btnClose;
  } else if (
    buttonText === "Update Address" ||
    buttonText === "Update Email" ||
    buttonText === "Update Bank Information" ||
    buttonText === "Update W-9" ||
    buttonText === "Use Original Address" ||
    buttonText === "Cancel Request" ||
    buttonText === "Use Original Address" ||
    buttonText === "No"
  ) {
    buttonStyle = styles.btnUpdate;
  } else if (
    buttonText === "Address is Correct" ||
    buttonText === "Email is Correct" ||
    buttonText === "Bank Information is Correct" ||
    buttonText === "Add New Bank Account" ||
    buttonText === "W-9 Information is Correct" ||
    buttonText === "Use Suggested Address" ||
    buttonText === "Verify" ||
    buttonText === "Resolve" ||
    buttonText === "Help" ||
    buttonText === "Add" ||
    buttonText === "Validate Email Address" ||
    buttonText === "Validate Address" ||
    buttonText === "Use Suggested Address" ||
    buttonText === "Select"
  ) {
    buttonStyle = styles.btnConfirm;
  } else if (buttonText === "Skip") {
    buttonStyle = styles.btnSkip;
  } else if (buttonText === "Go to Business Entity Page") {
    buttonStyle = styles.btnGoTo;
  } else if (buttonText === "Edit") {
    buttonStyle = styles.btnEdit;
  } else if (buttonText === "Add Entity Address") {
    buttonStyle = styles.btnEdit;
  } else if (buttonText === "Next") {
    buttonStyle = styles.btnNext;
  } else if (buttonText === "Cancel") {
    buttonStyle = styles.btnEdit;
  } else if (buttonText === "Remove") {
    buttonStyle = styles.btnRemove;
  } else if (buttonText === "Add Co-IBO") {
    buttonStyle = styles.btnEdit;
  } else if (buttonText === "Use Primary Address") {
    buttonStyle = styles.btnConfirm;
  } else if (buttonText === "Confirm Address Change") {
    buttonStyle = styles.btnConfirm;
  } else if (buttonText === "Validate This Email") {
    buttonStyle = styles.btnConfirm;
  } else if (buttonText === "Add A New Bank Account") {
    buttonStyle = styles.btnConfirm;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={classNames(styles.button, buttonStyle, className)}
      disabled={disabled}
    >
      {buttonText}
    </button>
  );
}
